<template>
  <div class="map-wrap">
    <div
        class="china-map"
        ref="chinaMap"      style="width: 100%; height: 100%"
    ></div>
    <!-- 地图切换: 面包屑 + 城市快捷按钮, 新增城市只需在 mapRegistry 加配置 -->
    <div class="map-nav">
      <template v-for="(key, index) in crumbs">
        <span class="crumb-split" :key="key + 'split'" v-if="index > 0">/</span>
        <span
            :key="key"
            :class="['crumb-item', key === currentMap ? 'active' : '']"
            @click="switchMap(key)"
        >{{ mapRegistry[key].label }}</span
        >
      </template>
      <div class="map-switch">
        <div
            v-for="key in cityKeys"
            :key="key"
            :class="['switch-btn', currentMap === key ? 'active' : '']"
            @click="switchMap(key)"
        >
          {{ mapRegistry[key].label }}
        </div>
      </div>
    </div>
    <!-- <img src="@/assets/img/copy.png" alt=""> -->
  </div>
</template>
<script>
// 引入资源
import * as echarts from "echarts";
import china from "@/until/china.json";
import { mapRegistry } from "@/until/mapRegistry";
import { pointInGeoJson } from "@/until/geoUtil";
// 各地图 GeoJSON 的加载 promise 缓存(模块级, 避免重复下载)
const regPromises = {};
let dian = [
  { name: "朱马店镇", value: [116.454858, 32.913925] },
  { name: "城关镇", value: [116.722615, 32.709243] },
  { name: "丁集镇", value: [116.6469973, 32.8283509] },
  { name: "顾桥镇", value: [116.545119, 32.834366] },
  { name: "顾桥镇临淝村", value: [116.55506, 32.79687] },
  { name: "顾桥镇搬迁安置区", value: [116.5468553777, 32.830945262] },
  { name: "凤凰镇", value: [116.720502, 32.709076] },
  { name: "泰安东岳大街", value: [117.114703, 36.189207] },
  { name: "万达广场", value: [117.087913, 36.180954] },
  { name: "济南市历下区经十路", value: [117.100243, 36.659148] },
];

export default {
  props: ["showInfo", "mapData"],
  data() {
    return {
      mapD: [],
      pointList: [],
      myChart:'',
      currentMap: "china",
      switching: false,
      registered: { china: china },
      mapRegistry,
      option: {
        tooltip: {
          show: true,
          triggerOn: "mousemove", //mousemove、click
          padding: [4, 8],
          borderWidth: 1,
          borderColor: "#409eff",
          backgroundColor: "rgba(255,255,255,0.7)",
          textStyle: {
            color: "#000000",
            fontSize: 13,
          },
          formatter: function (e) {
            return e.name;
          },
        },
        geo: [
          // 第一层
          {
            map: "china",
            z: 3,
            zoom: 1.2,
            aspectScale: 0.85,
            animationDurationUpdate: 0 /* 实现缩放、拖动同步且不卡顿 */,
            roam: true,
            top: "10%",
            layoutSize: "100%", //保持地图宽高比
            label: {
              show: true,
              color: "#fff",
            },
            regions: [
              {
                // 隐藏南海诸岛,因为顶层已经添加过了
                name: "南海诸岛",
                itemStyle: {
                  borderWidth: 0.5,
                  shadowBlur: 0,
                  borderColor: "#61aacb",
                  areaColor: "#104584",
                },
              },
            ],
            itemStyle: {
              borderColor: "#c8feff",
              borderWidth: 0.5,
              shadowBlur: 3,
              shadowColor: "#66edff",
              areaColor: "#0862db",
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                borderWidth: 1,
                areaColor: "#2da9ff",
              },
              label: {
                show: true,
                color: "#ffffff",
              },
            },
            select: {
              itemStyle: {
                shadowBlur: 10,
                borderWidth: 1,
                areaColor: "#2da9ff",
              },
              label: {
                color: "#ffffff",
              },
            },
          },
          // 第二层
          {
            map: "china",
            z: 2,
            zoom: 1.2,
            aspectScale: 0.85,
            animationDurationUpdate: 0 /* 实现缩放、拖动同步且不卡顿 */,
            roam: false,
            silent: true,
            top: "10%",
            layoutSize: "100%", //保持地图宽高比
            regions: [
              {
                // 隐藏南海诸岛,因为顶层已经添加过了
                name: "南海诸岛",
                itemStyle: {
                  opacity: 0, // 为 0 时不绘制该图形
                },
                label: {
                  show: false,
                },
              },
            ],
            itemStyle: {
              borderColor: "#d8feff",
              borderWidth: 3,
              shadowBlur: 10,
              shadowColor: "#22a1ff",
              areaColor: "#0862db",
              shadowOffsetX: 0,
              shadowOffsetY: 8,
            },
          },
          // 第三层
          {
            map: "china",
            z: 1,
            zoom: 1.2,
            aspectScale: 0.85,
            animationDurationUpdate: 0 /* 实现缩放、拖动同步且不卡顿 */,
            top: "11.5%",
            silent: true,
            layoutSize: "100%", //保持地图宽高比
            itemStyle: {
              borderColor: "#c8feff",
              borderWidth: 1,
              shadowBlur: 0,
              shadowColor: "#99c4ff",
              areaColor: "#4ebaff",
            },
            regions: [
              {
                // 隐藏南海诸岛,因为顶层已经添加过了
                name: "南海诸岛",
                itemStyle: {
                  opacity: 0, // 为 0 时不绘制该图形
                },
                label: {
                  show: false,
                },
              },
            ],
          },
          // 第四层
          {
            map: "china",
            z: 0,
            zoom: 1.2,
            aspectScale: 0.85,
            animationDurationUpdate: 0 /* 实现缩放、拖动同步且不卡顿 */,
            top: "12%",
            silent: true,
            layoutSize: "100%", //保持地图宽高比
            itemStyle: {
              borderColor: "#66edff",
              borderWidth: 2,
              shadowBlur: 20,
              shadowColor: "#4d99ff",
              areaColor: "#1752ad",
              shadowOffsetX: 0,
              shadowOffsetY: 8,
            },
            regions: [
              {
                // 隐藏南海诸岛,因为顶层已经添加过了
                name: "南海诸岛",
                itemStyle: {
                  opacity: 0, // 为 0 时不绘制该图形
                },
                label: {
                  show: false,
                },
              },
            ],
          },
        ],
        series: "",
      },
    };
  },
  created() {},
  computed: {
    // 面包屑链: 全国 > ... > 当前
    crumbs() {
      const list = [];
      let key = this.currentMap;
      while (key) {
        list.unshift(key);
        key = mapRegistry[key].parent;
      }
      return list;
    },
    // 快捷切换按钮: 除全国外的所有已注册地图
    cityKeys() {
      return Object.keys(mapRegistry).filter((key) => key !== "china");
    },
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.chinaMap);
    this.chinaEchart();
    this.getMapDataDetails();
    setInterval(() => {
      this.getMapDataDetails();
    }, 10000);
    // 后台预加载城市地图, 切换时不再现下载
    this.cityKeys.forEach((key) => {
      this.ensureRegistered(key).catch(() => {});
    });

  },
  methods: {
    // 加载并注册地图 GeoJSON(带 promise 缓存, 可重试)
    ensureRegistered(key) {
      if (this.registered[key]) {
        return Promise.resolve(this.registered[key]);
      }
      if (!regPromises[key]) {
        regPromises[key] = mapRegistry[key].json().then((mod) => {
          const geoJson = mod.default || mod;
          echarts.registerMap(key, geoJson);
          this.registered[key] = geoJson;
          return geoJson;
        });
      }
      return regPromises[key];
    },
    //获取地图数据
    getMapDataDetails() {
      this.$http.getMapDataDetails().then((res) => {
        // console.log("地图数据111", res);
        if (res.data.code == 200) {
          this.mapD = res.data.data;
          this.renderPoints();
        }
      });
    },
    // 复用四层 geo 样式, 只替换地图名
    buildGeo(mapName) {
      const geo = JSON.parse(JSON.stringify(this.option.geo));
      geo.forEach((layer) => {
        layer.map = mapName;
      });
      return geo;
    },
    // 切换地图(懒加载并注册 GeoJSON)
    async switchMap(key) {
      if (this.currentMap === key || !mapRegistry[key] || this.switching) return;
      this.switching = true;
      try {
        await this.ensureRegistered(key);
        this.currentMap = key;
        this.myChart.setOption({ geo: this.buildGeo(key) });
        this.renderPoints();
      } catch (e) {
        console.log("地图加载失败", e);
        regPromises[key] = null; // 允许下次点击重试
        this.$message.error("地图加载失败, 请重试");
      } finally {
        this.switching = false;
      }
    },
    async switchMapold(key) {
      if (this.currentMap === key || !mapRegistry[key]) return;
      if (!this.registered[key]) {
        const mod = await mapRegistry[key].json();
        const geoJson = mod.default || mod;
        echarts.registerMap(key, geoJson);
        this.registered[key] = geoJson;
      }
      this.currentMap = key;
      this.myChart.setOption({ geo: this.buildGeo(key) });
      this.renderPoints();
    },
    // 渲染涟漪散点(城市地图按 bbox 过滤点位)
    renderPoints() {
      const geoJson = this.registered[this.currentMap];
      const list =
          this.currentMap === "china"
              ? this.mapD
              : this.mapD.filter((item) =>
                  pointInGeoJson(item.value[0], item.value[1], geoJson)
              );
      this.pointList = list;
      this.myChart.setOption({
        series: [
          {
            name: "",
            type: "effectScatter",
            coordinateSystem: "geo",
            symbolSize: function (val) {
              //此处数字可调整散点大小
              return 14;
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            hoverAnimation: false,
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: false,
                color: "#fff",
              },
            },
            itemStyle: {
              normal: {
                color: "#1DE9B6",
                shadowBlur: 10,
                shadowColor: "#1DE9B6",
              },
            },
            zlevel: 1,
            //此处data渲染的就是地图的点位数据
            data: list.map(function (item) {
              return {
                name: item.name,
                value: [item.value[0], item.value[1], 1], // 最后一个数字控制涟漪特效的大小
              };
            }),
          },
        ],
      });
    },
    //打开弹窗
    showParentInfo(data) {
      this.$emit("showInfo", data);
    },
    // 方法
    chinaEchart() {
      var that = this;
      //注册地图，这个特别重要
      echarts.registerMap("china", china);
      let myChart = echarts.init(this.$refs.chinaMap);
      //echart 配制option
      var options = that.option;
      myChart.setOption(options);
      /* 缩放平移事件 */
      myChart.on("georoam", (params) => {
        let option = myChart.getOption(); //获得option对象
        let len = option.geo.length;
        if (params.zoom) {
          //捕捉到缩放时
          for (var i = 0; i < len; i++) {
            option.geo[i].center = option.geo[0].center;
            option.geo[i].zoom = option.geo[0].zoom;
          }
        } else {
          //捕捉到拖曳时
          for (var i = 0; i < len; i++) {
            option.geo[i].center = option.geo[0].center;
          }
        }
        myChart.setOption(option); //设置option
      });
      // 绑定点击事件
      myChart.on("click", function (params) {
        // console.log("被点击", params);
        if (params.seriesType === "effectScatter") {
          // 散点点击事件
          // console.log("散点被点击", params.dataIndex);
          that.showParentInfo(that.pointList[params.dataIndex].sosId);
          // 可以通过 params.data 获取散点的数据
        }
      });
    },
  },
};
</script>
<style scoped>.map-wrap {
  position: relative;
  width: 100%;
  height: 100%;
}
.china-map {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss" scoped>.map-nav {
  position: absolute;
  top: vw(10);
  left: vw(15);
  z-index: 900;
  display: flex;
  align-items: center;
  .crumb-item {
    cursor: pointer;
    color: #9fc7ff;
    font-size: vw(16);
    letter-spacing: vw(2);
    &.active {
      color: rgb(25, 236, 255);
    }
  }
  .crumb-split {
    margin: 0 vw(6);
    color: #9fc7ff;
    font-size: vw(16);
  }
  .map-switch {
    display: flex;
    margin-left: vw(20);
    .switch-btn {
      cursor: pointer;
      margin-right: vw(8);
      padding: vw(4) vw(14);
      font-size: vw(14);
      color: #fff;
      letter-spacing: vw(2);
      border: vw(1) solid rgba(79, 137, 224, 1);
      border-radius: vw(4);
      background: linear-gradient(
              180deg,
              rgba(54, 98, 164, 1) 0%,
              rgba(0, 10, 37, 0) 49.98%,
              rgba(54, 98, 164, 1) 100%
      );
      &.active {
        color: rgb(25, 236, 255);
        border-color: rgb(25, 236, 255);
      }
    }
  }
}
</style>